module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function (fox, localStorage) {
	"use strict";
	
	var _pnm = require('../components/push-notifications/manager')(fox);
	var _isPreviewMode = require('../../utils/is-preview-mode');

	fox.registerWidget('PushNotifications', {
		_lut: [],
		configure: function(options) {
			this.registerOptions('', {
				notificationsSite: fox.cookie.get('notifSite') ? fox.cookie.get('notifSite') : 'https://notifications.models.xxx',
				widgets: {
					checkSubscriptionStep1: {
						widget: 'Api',
						method: 'Notifications.checkSubscriptionStage1'
					},
					setupApi: {
						widget: 'Api',
						method: 'Notifications.setup'
					},
					allowApi: {
						widget: 'Api',
						method: 'Notifications.allow'
					},
					blockApi: {
						widget: 'Api',
						method: 'Notifications.block'
					},
					updateSubscriptionUserApi: {
						widget: 'Api',
						method: 'Notifications.updateSubscriptionUser'
					},
                    prompt: {
						widget: 'Widget',
						disabled: this.isDisabledRequest(),
                        autoRender: false,
                        manualRender: true,
                        template: 'request_permissions_message',
                        'embed.container': '#offline-notifications-message'
                    }
				},
				handleDom: {
					notificationPopupOpen: {
						targetWidget: '#prompt',
						target: '.push-notification-accept-btn',
						callback: 'openNotificationsCenterPopup'
                    },
                    disableRequest: {
						targetWidget: '#prompt',
						target: '.push-notification-disallow-btn',
						callback: 'disableRequest'
					},
					closeRequest: {
						targetWidget: '#prompt',
						target: '.close-prompt',
						callback: 'closeRequest'
					}
				},
				userIdentifier: null,
				windowParams: {
					width: 580,
					height: 580
				}
			});

			this.callParent('configure', arguments);
		},
		
		init: function () {
			// required for uuid generation
			for (var i=0; i < 256; i++) { 
				this._lut[i] = (i < 16 ? '0' : '')+(i).toString(16); 
			}

			this.callParent('init', arguments);
		},

		running: function () {
			this.callParent('running', arguments);

			this.notificationsRequestWidget = this.wom1('#prompt');
			
			this.blockApiInProgress = false;
			this.allowApiInProgress = false;

			if (_isPreviewMode()) {
				return;
			}

			window.setTimeout(function() {
				this.start();
			}.bind(this), 60000);
		},

		start: function() {
			var ident = this.getIdentifier();

			if (!ident) {
				ident = this._generateIdentifier();
				this.setIdentifier(ident);
			}

			this.setOption('userIdentifier', ident);
			
			return this.runCheckSubscriptionStep1().then(this.handleSubscriptionStep1.bind(this));
		},

		_requestPushNotifications: function(data) {
			if (this.notificationsRequestWidget._disabled === true || data.state === false) {
				return;
			}

			var userData = this.getUserData();
			var isMember = (userData !== null);
			var _promise = fox.Promise.resolve(true);
			var uid = this.getOption('userIdentifier');

			if (isMember && !this._subscriptionWasUpdated()) {
				_promise = this.wom1('#updateSubscriptionUserApi').psend({uid: uid}).then(function(resp) {
					localStorage.setItem('userSubscriptionUpdated', '1');

					return true;
				}.bind(this));
			}

			_promise.then(function() {
				this.notificationsRequestWidget.setTemplateOptions('location', window.location.origin);
				this.notificationsRequestWidget.render();
			}.bind(this));
		},

		openNotificationsCenterPopup: function(el, a, s, ev) {
			ev.preventDefault();

			if (this.allowApiInProgress === true) {
				return;
			}

			this.runAllowApi();
			this.openNewWindow();
			this.closeRequest();
		},

		_generateIdentifier: function() {
			var lut = this._lut;
			var d0 = Math.random() * 0xffffffff|0;
			var d1 = Math.random() * 0xffffffff|0;
			var d2 = Math.random() * 0xffffffff|0;
			var d3 = Math.random() * 0xffffffff|0;
			return lut[d0&0xff] + lut[d0>>8&0xff] + lut[d0>>16&0xff] + lut[d0>>24&0xff] + '-' +
				lut[d1&0xff] + lut[d1>>8&0xff] + '-' + lut[d1>>16&0x0f|0x40] + lut[d1>>24&0xff] + '-' +
				lut[d2&0x3f|0x80] + lut[d2>>8&0xff] + '-' + lut[d2>>16&0xff] + lut[d2>>24&0xff] +
				lut[d3&0xff] + lut[d3>>8&0xff] + lut[d3>>16&0xff] + lut[d3>>24&0xff];
		},

		_getCenterCoords: function() {
			var h = this.getOption('windowParams.height');
			var w = this.getOption('windowParams.width');
			
			var left = window.top.outerWidth / 2 + window.top.screenX - ( w / 2);
			var top = window.top.outerHeight / 2 + window.top.screenY - ( h / 2);
			return [left > 0 ? left : 0, top > 0 ? top : 0];
        },
        
        disableRequest: function() {

			if (this.blockApiInProgress === true) {
				return;
			}
			
			this.runBlockApi().then(function() {
				localStorage.setItem('notificationsRequestDisabled', 1);
				this.closeRequest();
			}.bind(this));
		},

		closeRequest: function() {
			this.notificationsRequestWidget._disabled = true;
			this.notificationsRequestWidget.removeFromDom();
		},
		
		isDisabledRequest: function() {
			return localStorage.getItem('notificationsRequestDisabled') === '1';
		},

		getIdentifier: function() {
			return localStorage.getItem('uid');
		},

		setIdentifier: function(ident) {
			return localStorage.setItem('uid', ident);
		},

		getUserData: function() {
			var memberInfo = fox.site.rwom1('.PermissionManager').getMemberInfo();

			return fox.isEmpty(memberInfo) ? null : memberInfo;
		},

		_subscriptionWasUpdated: function() {
			return localStorage.getItem('userSubscriptionUpdated') === '1';
		},

		runCheckSubscriptionStep1: function() {
			return this.wom1('#checkSubscriptionStep1').psend({uid: this.getOption('userIdentifier'), siteId: this.getSiteId()});
		},

		runSetupApi: function() {
			var api = this.wom1('#setupApi');
			var uid = this.getOption('userIdentifier');

			return _pnm.checkBrowser().then(function(data) {
				return api.psend({uid: uid, siteId: this.getSiteId(), browserSupport: data.state}).then(function() {
					return data;
				}.bind(this));
			}.bind(this));
		},

		runBlockApi: function() {
			this.blockApiInProgress = true;

			return this.wom1('#blockApi')
				.psend({uid: this.getOption('userIdentifier'), siteId: this.getSiteId()}).then(function() {
					this.blockApiInProgress = false;
				}.bind(this))
				.catch(function() {
					this.blockApiInProgress = false;
				}.bind(this));
		},

		runAllowApi: function() {
			this.allowApiInProgress = true;

			return this.wom1('#allowApi')
				.psend({uid: this.getOption('userIdentifier'), siteId: this.getSiteId()})
				.then(function() {
					this.allowApiInProgress = false;
				}.bind(this))
				.catch(function() {
					this.allowApiInProgress = false;
				}.bind(this));
		},

		handleSubscriptionStep1: function(resp) {
			var status = fox.objectGet(resp, 'params.answer.response');

			//any of actions done
			if (status === true) {
				return;
			}

			this.runSetupApi().then(this._requestPushNotifications.bind(this));
		},

		openNewWindow: function() {
			var newWin;
			var timer;
			var coords = this._getCenterCoords();
			var winOptsArray = [
				'scrollbars=yes',
				'width=' + this.getOption('windowParams.width'),
				'height=' + this.getOption('windowParams.height'),
				'left=' + coords[0],
				'top=' + coords[1]
			];
			var qpArray = [this.getSiteId()];

			qpArray.push(this.getIdentifier());
			
			newWin = window.open(
				this.getOption('notificationsSite') + '/subscribe/' + qpArray.join('/'), '_blank', winOptsArray.join(',')
			);

			timer = setInterval(function() { 
				if(newWin.closed) {
					window.clearInterval(timer);
				}
			}, 1000);
		},

		getSiteId: function() {
			return fox.site.dl.getObjectValue('id');
		}

	}, 'Controller');

})(fox, localStorage);

 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/widget/pushNotifications.js
// module id = 883
// module chunks = 4